<template>
  <div class="top-section__wrapper">
    <a-icon
      :icon="$options.consts.ICON.FMG_LOGO"
      width="auto"
      height="auto"
      :no-hover="true"
      class="top-section__main-logo"
    />

    <div class="top-section__overview-logos">
      <div class="top-section__overview">
        <h1 class="top-section__overview-title">
          Transform your brand in the Fintech Industry
        </h1>

        <p class="top-section__overview-subtitle">START. GROW. SCALE</p>

        <p class="text-body">
          Tap into our unique and extensive network. Ensure that your offerings
          are seamlessly presented to potential clients through our premium,
          targeted solutions—the largest and most influential in the fintech
          industry.
        </p>

        <a-button
          :href="$options.consts.FORM_HASH"
          :scroll-to-delay="$options.consts.FORM_SCROLL_TO_DELAY"
          :open-in-new-tab="false"
          class="top-section__overview-button"
          >TALK TO US</a-button
        >
      </div>

      <div class="top-section__logos">
        <homepage-top-section-animated-icons
          :icons="$options.consts.ANIMATED_ICONS"
          :aspect-ratio="$options.consts.ANIMATED_ICONS_ASPECT_RATIO"
        />
      </div>
    </div>
  </div>
</template>

<script>
import AIcon, { ICON } from 'shared/AIcon/index.vue'
import HomepageTopSectionAnimatedIcons from '@/components/_homepage/HomepageTopSection/HomepageTopSectionAnimatedIcons/index.vue'
import { ELEMENT_ID } from 'enums/element-id'
import { generateServerCacheKey } from '@/plugins/helper'
import { ASPECT_RATIO } from 'enums/aspectRatios'

export default {
  name: 'HomepageTopSection',
  serverCacheKey: () => generateServerCacheKey('HomepageTopSection'),
  components: { HomepageTopSectionAnimatedIcons, AIcon },
  consts: {
    ANIMATED_ICONS_ASPECT_RATIO: ASPECT_RATIO.TOP_SECTION_ICONS,
    FORM_HASH: `#${ELEMENT_ID.LEAD_FORM}`,
    FORM_SCROLL_TO_DELAY: 1500,
    ICON,
    ANIMATED_ICONS: [
      ICON.BUILD_CONNECTIONS,
      ICON.STAND_OUT,
      ICON.DRIVE_SALES,
      ICON.BOOST_VISIBILITY,
      ICON.INCREASE_IMPACT
    ]
  }
}
</script>

<style lang="scss" scoped>
@import '~assets/scss/local/mixins/grid';

.top-section__wrapper {
  .top-section__main-logo {
    $width: (
      $above-desktop-xl: 180px,
      $desktop-sm: 140px,
      $mobile: 112px
    );

    $height: (
      $above-desktop-xl: 73px,
      $desktop-sm: 57px,
      $mobile: 45px
    );

    @include setStyleByBreakpoint('width', $width);
    @include setStyleByBreakpoint('height', $height);

    @include mobile {
      margin: auto;
    }
  }

  .top-section__overview-logos {
    $margin-top: (
      $above-desktop-xl: 30px,
      $desktop-sm: 25px,
      $mobile: 30px
    );

    $grid-setup: (
      $columnSetup: (
        $above-desktop-xl: percentage(688px / $desktop-full-hd-container) 1fr,
        $desktop-sm: percentage(402px / $tablet-container) 1fr,
        $mobile: 100%
      ),
      $columnGapSetup: (
        $above-desktop-xl: 118px,
        $desktop-sm: 40px
      )
    );

    @include gridBuilder($grid-setup);
    @include setStyleByBreakpoint('margin-top', $margin-top);
  }

  .top-section__overview {
    @include mobile {
      order: 2;
      margin-top: 22px;
    }
  }

  .top-section__logos {
    @include mobile {
      order: 1;
      width: 200px;
      margin: 0 auto;
    }
  }

  .top-section__overview-title {
    line-height: 1.2;

    $font-size: (
      $above-desktop-xl: 60px,
      $desktop-sm: 35px,
      $mobile: 28px
    );

    @include setStyleByBreakpoint('font-size', $font-size);
  }

  .top-section__overview-subtitle {
    font-weight: 600;
    color: $c--main;

    $font-size: (
      $above-desktop-xl: 49px,
      $desktop-sm: 25px,
      $mobile: 18px
    );

    $margin-top: (
      $above-desktop-xl: 20px,
      $desktop-sm: 25px
    );

    $margin-bottom: (
      $above-desktop-xl: 20px,
      $desktop-sm: 25px,
      $mobile: 10px
    );

    @include setStyleByBreakpoint('font-size', $font-size);
    @include setStyleByBreakpoint('margin-top', $margin-top);
    @include setStyleByBreakpoint('margin-bottom', $margin-bottom);
  }

  .top-section__overview-button {
    border-radius: 4px;

    $font-size: (
      $desktop-sm: 16px,
      $mobile: 14px
    );

    $width: (
      $above-desktop-xl: 193px,
      $desktop-sm: 150px,
      $mobile: 130px
    );

    $height: (
      $above-desktop-xl: 58px,
      $desktop-sm: 45px,
      $mobile: 42px
    );

    $margin-top: (
      $above-desktop-xl: 30px,
      $desktop-sm: 28px,
      $mobile: 25px
    );

    @include setStyleByBreakpoint('font-size', $font-size);
    @include setStyleByBreakpoint('width', $width);
    @include setStyleByBreakpoint('height', $height);
    @include setStyleByBreakpoint('margin-top', $margin-top);
  }
}
</style>
